
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="card-wrapper type-modal" [formGroup]="productForm">
    <div class="card !pb-4">
      <h3 class="green decoration mb-4">Detalles del producto</h3>

      <div class="form-wrapper mb-3">
        <span>Nombre Unidad de Negocio:</span>
        <select formControlName="business_unit_id" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let businessUnitName of businessUnitNames" [value]="businessUnitName.id">{{ businessUnitName.name }}</option>
        </select>
      </div>
      <div class="form-wrapper mb-3">
        <span>Código Unidad de Negocio:</span>
        <input type="text" formControlName="business_unit_code" [attr.disabled]="true">
      </div>
      <div class="form-wrapper mb-3">
        <span>Línea de producto:</span>
        <select formControlName="product_line_id" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let productLine of productLines" [value]="productLine.id">{{ productLine.name }}</option>
        </select>
      </div>
      <div class="form-wrapper mb-3">
        <span>Código Línea de Producto:</span>
        <input type="text" value="Individual" formControlName="product_line_code" [attr.disabled]="true">
      </div>
      <div class="form-wrapper mb-3">
        <span>Nombre Producto:</span>
        <input type="text" formControlName="name" placeholder="Ej: Chatbots" [attr.disabled]="true">
      </div>
      <!-- <div class="form-wrapper">
        <span>Tipo de carga:</span>
        <select formControlName="charge_type_id" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let chargeType of chargeTypes" [value]="chargeType.id">{{ chargeType.name }}</option>
        </select>
      </div> -->
    </div>
    <div class="card !pb-4">
      <h3 class="green" style="margin-bottom: 1.6rem;">&nbsp;</h3>
      <div class="form-wrapper mb-3">
        <span>Código Interno:</span>
        <input type="text" formControlName="internal_code" placeholder="Ej: 1000001" [attr.disabled]="true">
      </div>
      <div class="form-wrapper mb-3">
        <span>Código Completo:</span>
        <input type="text" formControlName="total_code" [attr.disabled]="true">
      </div>
      <div class="form-wrapper mb-3">
        <span>Unidad de Medida Precio Base:</span>
        <input type="text" value="Bs" disabled>
      </div>
      <div class="mb-3">
        <div class="form-wrapper">
          <span>Tipo de precio:</span>
        </div>
        <div class="custom-radio-3">
          <label>
              <input type="radio" value="flat_fee" formControlName="type_pay" [attr.disabled]="true"/>
              <span>
                  <p>Tarifa plana</p>
              </span>
          </label>
          <label>
              <input type="radio" value="percentage" formControlName="type_pay" [attr.disabled]="true"/>
              <span>
                  <p>Porcentaje</p>
              </span>
          </label>
        </div>
      </div>
      <div class="form-wrapper mb-3">
        <span>Precio Base:</span>
        <div class="flex w-full items-center">
          <input type="number" formControlName="base_price" placeholder="Ej: 500" [attr.disabled]="true">
          <div *ngIf="productForm.get('type_pay').value == 'percentage'" class="font-bold text-2xl pl-4">%</div>
        </div>
      </div>

    </div>
    <h3 class="mb-1 px-6 w-full">Proveedores</h3>
    <div class="card-provider">
      <div class="provider-container" *ngFor="let providerGenerated of providersGenerated; let i = index">
        <!-- <h3 class="mb-1">Proveedor {{ i + 1 }}</h3> -->
        <div class="form-wrapper mb-3">
          <span>Proveedor:</span>
          <!-- <mat-select formControlName="provider_ids" placeholder="Seleccione una opción" multiple>
            <mat-option *ngFor="let provider of providers" [value]="provider.id">{{ provider.name | titlecase }}</mat-option>
          </mat-select> -->
          <select [formControlName]="providerGenerated.control_provider" [attr.disabled]="true">
            <option value="">Seleccione una opción</option>
            <option *ngFor="let provider of providers" [value]="provider.id">{{ provider.name }}</option>
          </select>
        </div>
        <div class="mb-3">
          <div class="form-wrapper">
            <span>Tipo de precio:</span>
          </div>
          <div class="custom-radio-3">
            <label>
                <input type="radio" value="flat_fee" [formControlName]="providerGenerated.control_type" [attr.disabled]="true"/>
                <span>
                    <p>Tarifa plana</p>
                </span>
            </label>
            <label>
                <input type="radio" value="percentage" [formControlName]="providerGenerated.control_type" [attr.disabled]="true"/>
                <span>
                    <p>Porcentaje</p>
                </span>
            </label>
          </div>
        </div>
        <!-- <div class="form-wrapper mb-3">
          <span>Costo Proveedor:</span>
          <div class="flex w-full items-center">
            <input type="number" [formControlName]="providerGenerated.control_cost" placeholder="Ej: 500" [attr.disabled]="true">
            <div *ngIf="productForm.get(providerGenerated.control_type).value == 'percentage'" class="font-bold text-2xl pl-4">%</div>
          </div>
        </div> -->
        <div class="form-wrapper mb-4">
          <span>Costo Proveedor:</span>
          <div class="flex w-full items-center">
            <input type="number" [formControlName]="providerGenerated.control_base" placeholder="Ej: 500" [attr.disabled]="true">
            <div *ngIf="productForm.get(providerGenerated.control_type).value == 'percentage'" class="font-bold text-2xl pl-4">%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <!-- <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>
